import { Component, ViewChild } from '@angular/core';
import { asyncScheduler, filter, map, Observable, observeOn } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { AdminManager } from '../../../managers/admin.manager';
import { LoginAttempt } from '../../../models/ui/login-attempt.model';

@Component({
    selector: 'lex-login-tracker',
    templateUrl: './login-tracker.component.html',
    styleUrls: ['./login-tracker.component.scss'],
    standalone: false
})
export class LoginTrackerComponent {
	public totalEntries$: Observable<number>;
	public hasPreviousPage$: Observable<boolean>;
	public hasNextPage$: Observable<boolean>;
	public dataSource$: Observable<MatTableDataSource<LoginAttempt>>;

	public columnsToDisplay = [
		'isSuccessful',
		'createdAt',
		'username',
		'ipAddress'
	];

	@ViewChild('paginator', { static: false }) paginator: MatPaginator;

	constructor(private adminManager: AdminManager) {
		this.dataSource$ = this.adminManager.loginAttemptCollection$.pipe(
			filter((collection) => !!collection),
			map((logCollection) => new MatTableDataSource(logCollection?.items))
		);

		this.totalEntries$ = this.adminManager.loginAttemptCollection$.pipe(
			map((collection) => collection?.totalItems || 0)
		);

		this.hasNextPage$ = this.totalEntries$.pipe(
			observeOn(asyncScheduler),
			map(() => this.paginator?.hasNextPage())
		);

		this.hasPreviousPage$ = this.totalEntries$.pipe(
			observeOn(asyncScheduler),
			map(() => this.paginator?.hasPreviousPage())
		);
	}

	export(): void {
		this.adminManager.exportLoginAttempts();
	}

	public loadPreviousPage(): void {
		this.paginator?.previousPage();
	}

	public loadNextPage(): void {
		this.paginator?.nextPage();
	}

	public movePage(event): void {
		const skip = event.pageIndex * event.pageSize;
		const take = event.pageSize;
		this.adminManager.refreshLoginAttemptCollection({ skip, take });
	}

}
